module.exports = __webpack_public_path__ + "static/media/feature2devices.dbd46fa3.png";